<template>
  <div>
    <div class="main-img">
      <vue-load-image v-if="image">
        <img slot="image" class="sa-fade-in" :src="image"/>
        <overlay-spinner slot="preloader" :size="35" :depth="3"/>
        <div slot="error" class="error">Failed to load image</div>
      </vue-load-image>
    </div>
  </div>
</template>

<script>
import VueLoadImage from 'vue-load-image';
import OverlaySpinner from "./OverlaySpinner";
import {mapGetters} from 'vuex';

export default {
  name: "ProductSlider",

  components: {
    VueLoadImage,
    OverlaySpinner,
  },

  computed: {
    ...mapGetters({
      image: 'shopify/product/image',
    }),
  },
};
</script>
